<mtg-table>
  <mtg-table-header-row mtgSticky="top" [top]="headerHeight">
    <mtg-table-identity-col></mtg-table-identity-col>
    <mtg-table-col>Матчей проведено</mtg-table-col>
    <mtg-table-col>Побед</mtg-table-col>
    <mtg-table-col>Поражения</mtg-table-col>
    <mtg-table-col>Очки</mtg-table-col>
    <mtg-table-col>% побед</mtg-table-col>
    <mtg-table-col>Разница мячей</mtg-table-col>
    <mtg-table-col>Последние 10 матчей</mtg-table-col>
  </mtg-table-header-row>
  <mtg-table-row *ngFor="let tournamentTeam of teams; let i = index;">
    <mtg-table-identity-col>
      <div class="number">{{ i + 1 }}</div>
      <div class="photo">
        <a
          [routerLink]="getTeamPageRoute(tournamentTeam.tournamentTeam.team.id)"
          queryParamsHandling="preserve"
        >
          <img [src]="tournamentTeam.tournamentTeam.logo.path"
               *ngIf="tournamentTeam.tournamentTeam.logo.path"
               [alt]="tournamentTeam.tournamentTeam.name"
          />
          <div [class]="tournamentTeam.tournamentTeam.team.getEmptyLogoClass()" *ngIf="!tournamentTeam.tournamentTeam.logo.path"></div>
        </a>
      </div>
      <div class="info">
        <div class="name">
          <a
            [routerLink]="getTeamPageRoute(tournamentTeam.tournamentTeam.team.id)"
            queryParamsHandling="preserve"
          >{{ tournamentTeam.tournamentTeam.name }}</a>
        </div>
      </div>
    </mtg-table-identity-col>
    <mtg-table-col>{{ tournamentTeam.gamesCount }}</mtg-table-col>
    <mtg-table-col>{{ tournamentTeam.wonGamesCount }}</mtg-table-col>
    <mtg-table-col>{{ tournamentTeam.gamesCount - tournamentTeam.wonGamesCount }}</mtg-table-col>
    <mtg-table-col>{{ tournamentTeam.points || 0 }}</mtg-table-col>
    <mtg-table-col>{{ tournamentTeam.gamesWonPercent }}%</mtg-table-col>
    <mtg-table-col>
      {{ tournamentTeam.scoreSum > tournamentTeam.missedSum ? '+' : ''}}
      {{ tournamentTeam.scoreSum - tournamentTeam.missedSum }}
    </mtg-table-col>
    <mtg-table-col>{{ tournamentTeam.lastGamesWon }} из {{ tournamentTeam.lastGamesCount }}</mtg-table-col>
  </mtg-table-row>
</mtg-table>
